export default __webpack_public_path__ + "static/media/american-express.ececc221.svg";